import { createContext, useContext } from 'react';

interface CreateBoundContextOptions<T> {
	defaultValue?: T;
	errorMessage?: string;
	hookName?: string;
	name?: string;
	providerName?: string;
}

const defaultErrorMessage = (hookName?: string, providerName?: string) => {
	return `${hookName} returned \`undefined\`. Did you forget to wrap your component in ${providerName}?`;
};

export const createBoundContext = <T>({ defaultValue, errorMessage, hookName, name, providerName }: CreateBoundContextOptions<T> = {}) => {
	const Context = createContext<T | undefined>(defaultValue);

	Context.displayName = name;

	const useBoundContext = () => {
		const context = useContext(Context);

		if (!context) {
			throw new Error(errorMessage ?? defaultErrorMessage(hookName, providerName));
		}

		return context;
	};

	return [Context.Provider, useBoundContext, Context] as [React.Provider<T>, () => T, React.Context<T>];
};
